const key = 'randomizer-state';

export const setRandomizerStateLocalStorage = (isActiveRandomizer: boolean) => {
  localStorage.setItem(
    key,
    JSON.stringify({
      isActiveRandomizer,
    }),
  );
};

export const getRandomizerStateLocalStorage = (): {
  isActiveRandomizer: boolean;
} => {
  const data = localStorage.getItem(key);

  if (data === null) {
    return {
      isActiveRandomizer: false,
    };
  } else {
    return JSON.parse(data);
  }
};
